import { Link } from 'react-router-dom';
import type { TvShow } from '@/mocks/tvShows';

interface MovieCardProps {
  show: TvShow;
  rank?: number;
}

export default function MovieCard({ show, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${show.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-xl bg-background-100 aspect-[3/4]">
        <img
          src={show.poster}
          alt={`${show.name} - ${show.englishName}`}
          title={`${show.name} ${show.tags.join(' ')}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-white text-xs leading-relaxed line-clamp-2">{show.description}</p>
          </div>
        </div>
        {show.status === 'updating' && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-[10px] font-medium rounded-md whitespace-nowrap">
            更新中
          </div>
        )}
        <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-black/70 text-primary-400 text-[10px] font-semibold rounded-md whitespace-nowrap">
          {show.rating}
        </div>
        {rank && (
          <div className="absolute bottom-1 left-2 w-7 h-7 flex items-center justify-center bg-accent-500 text-white font-heading font-bold text-sm rounded-lg">
            {rank}
          </div>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-foreground-900 font-medium text-sm leading-tight line-clamp-1">
          {show.name}
        </h3>
        <p className="text-foreground-400 text-xs mt-1 line-clamp-1">
          {show.updateInfo}
        </p>
      </div>
    </Link>
  );
}